import { render } from "./TrainingGroupListView.vue?vue&type=template&id=207d6020&scoped=true"
import script from "./TrainingGroupListView.vue?vue&type=script&lang=js"
export * from "./TrainingGroupListView.vue?vue&type=script&lang=js"

import "./TrainingGroupListView.vue?vue&type=style&index=0&id=207d6020&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207d6020"]])

export default __exports__